import type { PermissionId } from "@/lib/permissions/catalog";
import type { UserRole } from "@/lib/permissions/roles";

export type ClientPermissions =
	| PermissionId[]
	| readonly ["*"]
	| readonly PermissionId[]
	| undefined;

export function hasClientPermission(
	role: UserRole | undefined,
	permissions: ClientPermissions,
	permissionId: PermissionId,
): boolean {
	if (!role) return false;
	if (role === "admin") return true;
	if (permissions?.length === 1 && permissions[0] === "*") return true;
	return (permissions as readonly PermissionId[] | undefined)?.includes(permissionId) ?? false;
}
